import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { CampaignEntity } from './campaign.entity';

/**
 * One sending-provider campaign (in Instantly, essentially a single sequence)
 * belonging to a Workd campaign. A Workd campaign typically fans out to 5-20 of
 * these, and a contact is enrolled in exactly one (see CampaignMembershipEntity).
 *
 * Not auditable: rows are maintained by the provider sync (status / leadCount /
 * stats / lastSyncedAt), which would otherwise flood `_audit`.
 */
@Index('campaign_provider_campaign__external_uindex', ['externalCampaignId'], {
	unique: true,
})
@Index('campaign_provider_campaign__fk_campaign', ['fkCampaignId'], {})
@Entity('campaign_provider_campaign', {}, { auditable: false })
export class CampaignProviderCampaignEntity extends BaseEntity {
	@Column('int', { name: 'fk_campaign__id', unsigned: true })
	public fkCampaignId!: number;

	@Column('varchar', {
		name: 'provider',
		length: 50,
		default: () => "'instantly'",
	})
	public provider!: string;

	// The provider's campaign identifier (e.g. Instantly campaign id).
	@Column('varchar', { name: 'externalCampaignId', length: 255 })
	public externalCampaignId!: string;

	@Column('varchar', {
		name: 'externalCampaignName',
		length: 255,
		nullable: true,
	})
	public externalCampaignName!: string | null;

	@Column('varchar', { name: 'status', length: 50, nullable: true })
	public status!: string | null;

	@Column('int', { name: 'leadCount', nullable: true })
	public leadCount!: number | null;

	@Column('json', { name: 'stats', nullable: true })
	public stats!: Record<string, unknown> | null;

	@Column('datetime', { name: 'lastSyncedAt', nullable: true })
	public lastSyncedAt!: Date | null;

	@ManyToOne(() => CampaignEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_campaign__id', referencedColumnName: 'id' }])
	public fkCampaign!: CampaignEntity;
}
